import React, { FC } from 'react';
import { Button, Table } from 'antd';
import { WarningReviewIcon } from 'components/Elements/CustomSVGIcon';
import { FindStoreResult } from 'core/ftc/ftcApi';
import './multipleSitesPicker.scss';

interface MultipleSitesPickerProps {
    message: string;
    sites: FindStoreResult[];
    onSelect: (site: FindStoreResult) => void;
    // Disables the Select buttons while the chosen store is being added.
    isSelecting?: boolean;
}

// Shown when a post code covers more than one store (e.g. Brixton), so the
// user picks the right one instead of the first match being taken for them.
const MultipleSitesPicker: FC<MultipleSitesPickerProps> = ({ message, sites, onSelect, isSelecting = false }) => (
    <div className="multiple-sites-picker">
        {/* Same red icon + text notice as the app's other warnings. */}
        <div className="multiple-sites-warning" role="alert">
            <WarningReviewIcon />
            <span className="multiple-sites-warning-text">{message}</span>
        </div>
        <Table
            dataSource={sites}
            rowKey="siteId"
            pagination={false}
            size="small"
            className="multiple-sites-table"
            columns={[
                {
                    title: 'Store Code',
                    dataIndex: 'storeCode',
                    key: 'storeCode',
                    render: (val: string | null) => val || '-',
                },
                {
                    title: 'Store Location',
                    dataIndex: 'siteName',
                    key: 'siteName',
                    render: (val: string | null) => val || '-',
                },
                {
                    title: 'Address',
                    dataIndex: 'siteAddress',
                    key: 'siteAddress',
                    render: (val: string | null) => val || '-',
                },
                {
                    title: 'Post Code',
                    dataIndex: 'sitePostcode',
                    key: 'sitePostcode',
                    render: (val: string | null) => val || '-',
                },
                {
                    title: ' ',
                    key: 'select',
                    width: 120,
                    align: 'right' as const,
                    render: (_: unknown, site: FindStoreResult) => (
                        <Button
                            type="primary"
                            className="select-site-button"
                            disabled={isSelecting}
                            aria-label={`Select ${site.siteName || site.storeCode}`}
                            onClick={() => onSelect(site)}>
                            Select
                        </Button>
                    ),
                },
            ]} />
    </div>
);

export default MultipleSitesPicker;
